import React from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WebsiteRoutes from "./WebsiteRoutes";
export default function WebsiteApp() {
  return (
    <>
      <Header />
      <main style={{ paddingTop: "5rem" }}>
        <WebsiteRoutes />
      </main>
      <Footer />
    </>
  );
}